import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[JARVIS ErrorBoundary]', error, info.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: '#07091a', display: 'flex',
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'system-ui, -apple-system, sans-serif', color: '#e2e8f0',
        padding: '40px',
      }}>
        <div style={{
          background: 'rgba(255,51,51,0.08)', border: '1px solid rgba(255,51,51,0.25)',
          borderRadius: '16px', padding: '40px', maxWidth: '520px', width: '100%',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <div style={{
            fontSize: '20px', fontWeight: '800', color: '#ff3333',
            letterSpacing: '2px', marginBottom: '12px',
          }}>
            JARVIS SYSTEM ERROR
          </div>
          <div style={{ fontSize: '14px', color: 'rgba(226,232,240,0.6)', lineHeight: '1.6', marginBottom: '24px' }}>
            Something crashed inside JARVIS. Your data is safe — it's stored in the browser.<br />
            Reload to restart JARVIS.
          </div>

          {this.state.error && (
            <div style={{
              background: 'rgba(0,0,0,0.4)', border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '8px', padding: '12px', marginBottom: '24px',
              textAlign: 'left', maxHeight: '120px', overflow: 'auto',
            }}>
              <code style={{ fontSize: '12px', color: '#ff6b6b', fontFamily: 'monospace', lineHeight: '1.5' }}>
                {this.state.error.toString()}
              </code>
            </div>
          )}

          <button
            onClick={this.handleReload}
            style={{
              background: 'linear-gradient(135deg, #00d4ff22, #00d4ff11)',
              border: '1px solid #00d4ff44', borderRadius: '10px',
              color: '#00d4ff', fontSize: '14px', fontWeight: '700',
              padding: '12px 28px', cursor: 'pointer', letterSpacing: '1px',
            }}
          >
            🔄 Reload JARVIS
          </button>
        </div>
      </div>
    );
  }
}
